<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="app-container pa-4">
        <h1 class="pb-4 font-weight-bold text-center">{{ companyData.name }}</h1>
        <v-card outlined class="border-transparent br-10">
            <v-row>
                <v-col cols="12" sm="12" md="2" class="d-flex flex-column align-center text-center">
                    <img :src="avatar"  class="company-image my-3"/>
                    <v-card-actions>
                        <v-rating
                            :value="companyRate.value"
                            color="orange lighten-2"
                            dense
                            small
                            background-color="orange lighten-2"
                            readonly
                        ></v-rating>
                        <span class="orange--text text--lighten-2">({{ companyRate.total }})</span>
                    </v-card-actions>
                    <v-card-text class="py-0 text--main-yellow text-lowercase text-underline"><a class="pa-0 ma-0 text--main-yellow" href="#feedback">{{ companyFeedbackTotal }} {{ $t('feedbacks') }}</a>  </v-card-text>
                </v-col>

                <v-col cols="12" sm="12" md="4" class="pt-0 px-6 px-md-0 pt-md-4">
                    <div class="d-flex py-2">
                        <v-icon class="text--main-yellow pr-4">place</v-icon>
                        <div class="font-weight-bold">{{ $t('addressFact') }}: <span class="font-weight-light">{{ companyData.address }}</span></div>
                    </div>
                    <div class="d-flex py-2">
                        <v-icon class="text--main-yellow pr-4">settings_phone</v-icon>
                        <div class="font-weight-bold">{{ $t('telephone') }}: <span class="font-weight-light">{{ companyData.phone }}</span></div>
                    </div>
                    <div class="d-flex py-2">
                        <v-icon class="text--main-yellow pr-4">mail</v-icon>
                        <div class="font-weight-bold">Email : <span class="font-weight-light">{{ companyData.email }}</span></div>
                    </div>
                    <div class="d-flex py-2">
                        <v-icon class="text--main-yellow pr-4">language</v-icon>
                        <div class="font-weight-bold">{{ $t('website') }}: <a :href="companyLink"><span class="font-weight-light">{{ siteName }}</span></a></div>
                    </div>
                    <div class="d-flex justify-center pt-4" v-if="companyId !== user">
                        <v-btn dark depressed class="px-9 subtitle-1" color="main--yellow"  v-if="isUserLoggedIn" @click="actionMessage">{{$t('writeToSeller')}}</v-btn>
                    </div>
                </v-col>

                <v-col cols="12" sm="12" md="6" class="">
                    <div class="card-border-left">
                        <v-card-title class="font-weight-bold d-flex justify-center pt-0">{{ $t('sellerInformation') }}</v-card-title>
                        <v-card class="overflow-y background-transparent border-transparent" height="250">
                            <v-card-text class="black--text " v-html="companyData.description"></v-card-text>
                        </v-card>
                    </div>
                </v-col>
            </v-row>
        </v-card>

        <v-row v-if="companyContactsData.length">
            <v-col cols="12" md="12" class="py-0">
                <v-card-title class="font-weight-bold d-flex justify-center">{{ $t('companyRepresentatives') }}</v-card-title>
                <v-row class="d-flex">
                    <v-col
                        cols="12" sm="6" md="3" class="py-0 px-7 pa-md-0"
                        v-for="(contact,i) in companyContactsData"
                        :key="contact.id"
                    >
                        <v-expansion-panels accordion class="px-2" multiple flat>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-card-title class="pa-0" v-text="getContactString(i)"></v-card-title>
                                    <template v-slot:actions>
                                        <v-icon>$expand</v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-divider></v-divider>
                                <v-expansion-panel-content>
                                    <div class="py-2 font-weight-bold">{{ $t('firstName') }}: <span class="font-weight-light">{{ contact.firstName }}</span></div>
                                    <div class="py-2 font-weight-bold">{{ $t('lastName') }}: <span class="font-weight-light">{{ contact.lastName }}</span></div>
                                    <div class="py-2 font-weight-bold">Email: <a :href="`mailto:${contact.email}`" class="font-weight-light text--black">{{ contact.email }}</a></div>
                                    <div class="py-2 font-weight-bold">{{ $t('telephone') }}: <a :href="`tel:${contact.phone}`" class="font-weight-light text--black">{{ contact.phone }}</a></div>
                                    <div class="py-2 font-weight-bold" v-if="contact.phone2">{{ $t('telephone') }} 2: <a :href="`tel:${contact.phone2}`" class="font-weight-light text--black">{{ contact.phone2 }}</a></div>
                                </v-expansion-panel-content>
                                <v-divider></v-divider>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row class="justify-center">
            <v-col cols="12" md="9" class="pb-0">
                <v-card-title class="font-weight-bold pb-md-0 d-flex justify-center">{{$t('sellersProducts')}}
                    <span class="pl-4">{{companyData.name}}</span>
                </v-card-title>
                <v-row class="d-flex justify-center">
                    <v-col cols="12">
                        <div class="skeleton-text-short" v-if="listLoading">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                        </div>
                        <div class="overline text-center" v-else>{{$t('productsFound')}}: {{total}}</div>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                        <product-list
                            :loading="listLoading"
                            :products="products"
                            :total="total"
                            :init-page="page"
                            :last-page="lastPage"
                            :is-visible-more-button="loadMore"
                            @show-more="incrementPage"
                            @change-page="setPage"
                        ></product-list>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="12" class="pt-0">
                <v-card-title class="font-weight-bold d-flex justify-center" id="feedback">{{$t('feedbackAboutCompany')}}
                    <span class="pl-4">{{companyData.name}}</span>
                </v-card-title>
                <div class="d-flex justify-center justify-md-space-between flex-wrap">
                    <div v-if="companyId !== user">
                        <v-btn
                            dark
                            depressed
                            class="px-9 subtitle-1"
                            color="main--yellow"
                            v-if="isUserLoggedIn"
                            @click="actionCompanyMessage"
                        >
                            {{$t('addSellerFeedback')}}
                        </v-btn>
                    </div>

                    <v-card-actions class="mobile-position-center">
                        <v-rating
                            :value="companyRate.value"
                            color="orange lighten-2"
                            dense
                            small
                            background-color="orange lighten-2"
                            readonly
                        ></v-rating>
                        <span class="text--main-yellow pr-4">({{ companyRate.total }})</span>
                        <div class="text--main-yellow"> {{ companyFeedbackTotal }}  {{ $t('feedbacks') }}</div>
                    </v-card-actions>
                </div>

            </v-col>
        </v-row>
        <div v-if="!companyFeedbackTotal" class="subtitle-1 font-weight-bold d-flex justify-center text-center" > {{ $t('noFeedbacks') }}</div>
        <v-card
            v-for="(feedback,i) in companyFeedback"
            :key="i"
            class="br-10 mb-6"
            outlined
        >
            <v-row>
                <v-col cols="12" md="3">
                    <v-card-text class="d-flex justify-center caption pt-0">{{ feedback.createdAt }}</v-card-text>
                    <v-card-title class="d-flex justify-center py-0">{{ feedback.userName }}</v-card-title>
                </v-col>
                <v-col cols="12" md="9" class="">
                    <v-divider class="hidden-sm-and-up"></v-divider>
                    <div class="card-border-left">
                        <v-card-text>{{ feedback.content }}</v-card-text>
                    </div>
                </v-col>
            </v-row>
        </v-card>
        <company-dialog
            :isOpen="sellerMessageOpen"
            :company="company"
            @close="sellerMessageOpen = false"
        ></company-dialog>
        <company-feedback-dialog
            :isOpen="companyMessageOpen"
            :company="company"
            :company-name="companyData.name"
            @close="companyMessageOpen = false"
            @feedback-change="feedbackChange()"
            @rating-change="ratingChange()"
        ></company-feedback-dialog>
    </div>
</template>

<script>

import Auth from '../../../../app-front/mixins/Auth';
import ActionAccess from '../../../../app-front/mixins/ActionAccess';
import AppBreadcrumbs from '../../../../app-front/mixins/AppBreadcrumbs';
import Breadcrumbs from '../../../../app-front/components/breadcrumbs';
import CompanyService from '../../../../app-front/services/api/CompanyService';
import Meta from '../../../../app-front/mixins/Meta'
import ProductList from '../../../../app-front/components/product/product-list';
import CompanyDialog from '../../../../app-front/components/dialogs/CompanyDialog'
import CompanyFeedbackDialog from '../../../../app-front/components/dialogs/CompanyFeedbackDialog'
import ProductsPagination from '../../../../app-front/mixins/ProductsPagination';

export default {
    name: "CompanyPageGeneral",
    props: ['id','parent'],
    mixins:[AppBreadcrumbs, Meta, ActionAccess, Auth, ProductsPagination],
    components:{Breadcrumbs, ProductList, CompanyDialog, CompanyFeedbackDialog},
    data() {
        return {
            metaUrl: '/company/' + this.id,
            company: this.id,
            breadcrumbsData: {
                page: 'companyPageGeneral',
                data:{
                    companyId: this.id
                }
            },
            companyData: {
                address: null,
                email: null,
                phone: null,
                siteLink: null,
                name: null,
                description: null,
                image: {},
            },
            companyContactsData: [
                {
                    contactName: null,
                    firstName: null,
                    lastName: null,
                    email: null,
                    phone: null,
                    skypeNickname: null
                }
            ],
            sellerMessageOpen: false,
            companyMessageOpen: false,
            sellerMessageProduct: null,
            companyMessageProduct: null,
            companyRate: {
                companyId: this.id,
                value: null,
                total: null,
            },
            companyFeedback: [],
            companyFeedbackTotal: null,
            userId: null,
            sortData: {
                sortType: 'date',
                order: 'desc',
            }
        }
    },
    computed: {
        companyLink() {
            if(this.companyData.siteLink === null) return null;

            return (this.companyData.siteLink.indexOf("http://") === 0 || this.companyData.siteLink.indexOf("https://") === 0) ?
                this.companyData.siteLink : 'https://' + this.companyData.siteLink;
        },
        avatar() {
            return this.companyData.image.url ? this.companyData.image.url : '/images/default-user.png';
        },
        user() {
            return this.userId;
        },
        companyId() {
            return this.companyData.id;
        },
        filters() {
            return { user: this.companyData.userId };
        },
        siteName() {
            if(!this.companyData.siteLink)
                return '';

            return this.companyData.siteLink.length > 30 ? this.$t('goTo').toLowerCase() : this.companyData.siteLink.length;
        }
    },
    methods: {
        authSuccessActionHandle(data) {
            switch(data.type) {
                case 'message' : this.$emit('message'); break;
            }
        },
        actionMessage() {
            this.sellerMessageProduct = this.id;
            this.sellerMessageOpen = true;
        },
        actionCompanyMessage() {
            this.companyMessageProduct = this.id;
            this.companyMessageOpen = true;
        },
        feedbackChange() {
            this.getFeedbacks();
        },
        ratingChange() {
            this.getRating();
        },
        getContactString(idx) {
            return this.companyContactsData[idx].contactName ? this.companyContactsData[idx].contactName : this.$t('contactPerson')
        },
        getData() {
            CompanyService.setLocale(this.$store.state.language.appLanguage);
            CompanyService.getCompany(this.id)
                .then(res => {
                    this.companyData = res.data.companyData;
                    this.companyContactsData = res.data.companyContactsData;
                    this.setProducts();
                })
                .catch(err => {
                    console.log(err);
                });

            CompanyService.getUser()
                .then(res => {
                    this.userId =  res.data.id;
                })
                .catch(err => {
                    console.log(err);
                });

            this.getRating();
            this.getFeedbacks();
        },
        getRating() {
            CompanyService.getCompanyRate(this.id)
                .then(res => {
                    this.companyRate = res.data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getFeedbacks() {
            CompanyService.getCompanyFeedback(this.id)
                .then(res => {
                    this.companyFeedback = res.data;
                    this.companyFeedbackTotal = this.companyFeedback.length;
                })
                .catch(err => {
                    console.log(err);
                });
        },
    },
    beforeMount() {
        this.getData();
    },
    watch: {
        id() {
            this.metaUrl = '/company/' + this.id;
            this.getMetaData();
            this.getData();
        }
    }
}
</script>

<style scoped>
.company-image {
    border:1px solid #F5B821;
    background: #fff;
    width: 150px;
    height: 150px;
    object-fit: contain;
    border-radius: 50%;
}
.app-container .background-transparent.v-card {
    background: transparent;
    box-shadow: none;
}
.app-container .border-transparent.v-card {
    box-shadow: none;
}
.card-border-right {
    border-right: rgba(0, 0, 0, 0.12) solid 1px !important;
}
.card-border-left {
    border-left: rgba(0, 0, 0, 0.12) solid 1px !important;
}
/*Mobile version*/
@media screen and (max-width: 800px) {
    .company-image {
        width: 100px;
        height: 100px;
    }
    .card-border-right {
        border-right: transparent solid 1px !important;
    }
    .card-border-left {
        border-left: transparent solid 1px !important;
    }
}
</style>
